import React, { useEffect, useState } from 'react'
import { GetAll_Active_Now_Period_Api } from '../../API/PeriodApi';
import { Button, Col, Row, Checkbox, Card, Modal, Typography, Space } from 'antd';
import {
  CalendarOutlined,
  TrophyOutlined,
  FileTextOutlined,
  DoubleLeftOutlined
} from '@ant-design/icons';
// ======================================================================
const { Paragraph, Text , Title} = Typography;

export const ShowActivePeriodComponent = ({ setLoading, showMessage, onNewReserveClick }) => {
    const [periods, setPeriods] = useState([]);
    const [selectedPeriod, setSelectedPeriod] = useState();
    const [acceptedTerms, setAcceptedTerms] = useState(false);
    const [hasViewedDetails, setHasViewedDetails] = useState(false); // آیا کاربر توضیحات را باز/مشاهده کرده؟
    const [detailsModalVisible, setDetailsModalVisible] = useState(false);

    useEffect(() => {
        loadData();
    }, []);

    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetAll_Active_Now_Period_Api();
            setLoading(false);
            if (data.messageStatus == "Successful") {
                setPeriods(data.messageData.data);
            } else {
                showMessage(data.message, "error")
            }
        } catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }

    // وقتی دوره تغییر کرد، وضعیت تیک و مشاهده ریست شود
    const handleSelectPeriod = (period) => {
        setSelectedPeriod(period);
        setAcceptedTerms(false);
        setHasViewedDetails(false);
    }

    // هنگام باز کردن modal، علامت مشاهده فعال شود (می‌تونید به جای این، بررسی پیمایش داخل modal هم اضافه کنید)
    const openDetailsModal = () => {
        setDetailsModalVisible(true);
        setHasViewedDetails(true);
    }

    const closeDetailsModal = () => {
        setDetailsModalVisible(false);
    }

    // تبدیل ارقام لاتین -> فارسی
    const toPersianDigits = (str) =>
        str.replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d]);

    // فرمت شبیه 1404-8-5 -> ۱۴۰۴/۰۸/۰۵
    const formatShamsiDate = (dateStr) => {
        if (!dateStr) return '';
        const parts = dateStr.split(/[-\/]/);
        if (parts.length < 3) return toPersianDigits(dateStr);
        const [y, m, d] = parts;
        const mm = m.padStart(2, '0');
        const dd = d.padStart(2, '0');
        return toPersianDigits(`${y}/${mm}/${dd}`);
    };

    // آیا چک‌باکس باید قابل تیک زدن باشد؟
    // اگر توضیحات وجود داشته باشد، کاربر باید ابتدا آن را باز کند/مشاهده کند (hasViewedDetails)
    const canToggleCheckbox = !selectedPeriod?.comment || hasViewedDetails;

    // اگر دوره‌ای وجود ندارد
if (periods.length === 0) {
    return (
        <Card
            style={{
                maxWidth: '600px',
                margin: '40px auto',
                textAlign: 'center',
                borderRadius: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                border: '1px solid #f0f0f0'
            }}
            bodyStyle={{ padding: '40px' }}
        >
            <div style={{ fontSize: '72px', marginBottom: '20px', color: '#bfbfbf' }}>
                📭
            </div>
            
            <Title level={3} style={{ color: '#434343', marginBottom: '16px' }}>
                دوره فعالی یافت نشد
            </Title>
            
            <Paragraph style={{ 
                color: '#8c8c8c', 
                fontSize: '16px',
                lineHeight: '1.6',
                marginBottom: '32px'
            }}>
                در حال حاضر هیچ دوره‌ای برای ثبت‌نام در دسترس نیست.
                <br />
                ممکن است زمان ثبت‌نام به پایان رسیده باشد یا هنوز شروع نشده باشد.
            </Paragraph>
            
            <Space direction="vertical" size={16} style={{ width: '100%' }}>
                <Button 
                    type="primary" 
                    size="large"
                    onClick={loadData}
                    style={{
                        height: '48px',
                        padding: '0 32px',
                        fontSize: '16px',
                        borderRadius: '8px'
                    }}
                    icon={<span style={{ marginLeft: '8px' }}>🔄</span>}
                >
                    بروزرسانی و بررسی مجدد
                </Button>
                
                <div style={{ 
                    background: '#fafafa', 
                    padding: '16px', 
                    borderRadius: '6px',
                    border: '1px dashed #d9d9d9'
                }}>
                    <Text type="secondary">
                        💡 برای اطلاعات بیشتر با پشتیبانی تماس بگیرید
                    </Text>
                </div>
            </Space>
        </Card>
    );
}

    return (
        <>
            <Row justify="space-around" style={{ marginTop: 15 }}>
                {periods.map((period, key) =>
                    <Col key={key} xs={23} sm={22} md={11} lg={10} xl={10}
                        style={{
                            border: '1px solid rgba(0,0,0,0.08)',
                            borderRadius: 8,
                            textAlign: 'center',
                            padding: 12,
                            margin: 6,
                            cursor: "pointer",
                            boxShadow: period.id == selectedPeriod?.id ? '0 6px 20px rgba(0,0,0,0.08)' : '0 4px 10px rgba(0,0,0,0.03)',
                            transition: 'transform .12s ease',
                            transform: period.id == selectedPeriod?.id ? 'translateY(-4px)' : 'none'
                        }}
                        className={period.id == selectedPeriod?.id ? 'btn-info' : ''}
                        onClick={() => handleSelectPeriod(period)}
                    >
                        <h3 style={{ marginBottom: 6 }}>{period.title}</h3>
                        <Text type="secondary">{period.categoryTitle}</Text>
                    </Col>
                )}
            </Row>

{selectedPeriod && (
    <>
        <Card
            style={{
                borderRadius: 8,
                marginTop: 12,
                padding: 12,
            }}
            title={
                <div style={{ fontSize: 14, fontWeight: 600 }}>
                    📅 اطلاعات دوره
                </div>
            }
        >
            <Row gutter={[16, 8]} align="middle" style={{ fontSize: 13 }}>
                {/* تمام اطلاعات در یک ردیف برای دسکتاپ */}
                <Col xs={12} sm={6} md={3} lg={3}>
                    <div style={{ textAlign: 'center' }}>
                        <CalendarOutlined style={{ color: '#1890ff', fontSize: 16, display: 'block', marginBottom: 4 }} />
                        <div style={{ color: '#666', fontSize: 11, marginBottom: 2 }}>شروع ثبت‌نام</div>
                        <div style={{ fontWeight: 600, fontSize: 12 }}>
                            {formatShamsiDate(selectedPeriod.registration_From_Shamsi) || '-'}
                        </div>
                    </div>
                </Col>

                <Col xs={12} sm={6} md={3} lg={3}>
                    <div style={{ textAlign: 'center' }}>
                        <CalendarOutlined style={{ color: '#1890ff', fontSize: 16, display: 'block', marginBottom: 4 }} />
                        <div style={{ color: '#666', fontSize: 11, marginBottom: 2 }}>پایان ثبت‌نام</div>
                        <div style={{ fontWeight: 600, fontSize: 12 }}>
                            {formatShamsiDate(selectedPeriod.registration_To_Shamsi) || '-'}
                        </div>
                    </div>
                </Col>

                <Col xs={12} sm={6} md={3} lg={3}>
                    <div style={{ textAlign: 'center' }}>
                        <CalendarOutlined style={{ color: '#52c41a', fontSize: 16, display: 'block', marginBottom: 4 }} />
                        <div style={{ color: '#666', fontSize: 11, marginBottom: 2 }}>شروع اقامت</div>
                        <div style={{ fontWeight: 600, fontSize: 12 }}>
                            {formatShamsiDate(selectedPeriod.from_Shamsi) || '-'}
                        </div>
                    </div>
                </Col>

                <Col xs={12} sm={6} md={3} lg={3}>
                    <div style={{ textAlign: 'center' }}>
                        <CalendarOutlined style={{ color: '#52c41a', fontSize: 16, display: 'block', marginBottom: 4 }} />
                        <div style={{ color: '#666', fontSize: 11, marginBottom: 2 }}>پایان اقامت</div>
                        <div style={{ fontWeight: 600, fontSize: 12 }}>
                            {formatShamsiDate(selectedPeriod.to_Shamsi) || '-'}
                        </div>
                    </div>
                </Col>

                {/* قرعه‌کشی */}
                {selectedPeriod.isLottery && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 8,
                            padding: '6px 12px',
                            background: '#f9f0ff',
                            borderRadius: 6,
                            justifyContent: 'center',
                            height: '100%'
                        }}>
                            <TrophyOutlined style={{ color: '#722ed1', fontSize: 14 }} />
                            <span style={{ color: '#666', fontSize: 11 }}>تاریخ قرعه‌کشی:</span>
                            <span style={{ fontWeight: 600, fontSize: 12, color: '#722ed1' }}>
                                {formatShamsiDate(selectedPeriod.lotteryDate_Shamsi) || '-'}
                            </span>
                        </div>
                    </Col>
                )}
            </Row>
        </Card>
 

{selectedPeriod.comment && (
    <Card
        style={{ 
            marginTop: 16, 
            borderRadius: 8, 
            background: 'linear-gradient(135deg, #fff9e6 0%, #ffe7ba 100%)',
            border: '2px solid #fa8c16',
            boxShadow: '0 4px 12px rgba(250, 140, 22, 0.15)'
        }}
        bodyStyle={{ padding: 16 }}
        bordered={false}
    >
        <Space direction="vertical" size={12} style={{ width: '100%' }}>
            {/* هدر شرایط */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                <FileTextOutlined style={{ 
                    color: '#fa541c', 
                    fontSize: 18,
                    background: '#fff',
                    padding: 4,
                    borderRadius: 4
                }} />
                <Text strong style={{ 
                    fontSize: 15, 
                    color: '#d4380d',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6
                }}>
                    📋 شرایط و مقررات ثبت‌نام
                    <span style={{
                        background: '#ff4d4f',
                        color: 'white',
                        fontSize: 11,
                        padding: '2px 6px',
                        borderRadius: 10,
                        marginRight: 4
                    }}>
                        مهم
                    </span>
                </Text>
            </div>
            
            {/* بخش متن شرایط با اسکرول */}
            <div style={{
                background: 'rgba(255, 255, 255, 0.8)',
                padding: '16px',
                borderRadius: '8px',
                border: '1px solid #ffd591',
                maxHeight: '200px', // ارتفاع بیشتر برای نمایش اطلاعات بیشتر
                overflowY: 'auto',
                position: 'relative'
            }}>
                <div 
                    style={{ 
                        lineHeight: 1.7,
                        fontSize: 13,
                        color: '#8c6c13',
                        minHeight: '150px'
                    }}
                    dangerouslySetInnerHTML={{ __html: selectedPeriod.comment }} 
                />
            </div>
            
            {/* دکمه مطالعه کامل در زیر متن */}
            <div style={{ textAlign: 'center', paddingTop: 8 }}>
                <Button 
                    type="primary" 
                    onClick={openDetailsModal}
                    style={{
                        background: '#fa541c',
                        borderColor: '#fa541c',
                        borderRadius: 6,
                        fontWeight: 600,
                        boxShadow: '0 2px 8px rgba(250, 84, 28, 0.4)',
                        width: '100%',
                        maxWidth: '300px',
                        height: '44px',
                        fontSize: 14
                    }}
                    icon={<FileTextOutlined />}
                    size="large"
                >
                    مطالعه کامل شرایط و مقررات
                </Button>
                
                <Text type="secondary" style={{ 
                    fontSize: 12, 
                    display: 'block', 
                    marginTop: 8,
                    color: '#d48806'
                }}>
                    📖 برای ثبت‌نام نهایی باید کلیه شرایط را مطالعه و قبول کنید
                </Text>
            </div>
        </Space>
    </Card>
)}

{/* Modal برای نمایش کامل شرایط و مقررات */}
<Modal
    title={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <FileTextOutlined style={{ color: '#fa541c' }} />
            <span>شرایط و مقررات ثبت‌نام - مطالعه کامل</span>
        </div>
    }
    visible={detailsModalVisible}
    onCancel={closeDetailsModal}
    footer={[
        <Button key="close" onClick={closeDetailsModal}>
            بستن
        </Button>,
        <Button 
            key="accept" 
            type="primary" 
            onClick={() => { 
                setHasViewedDetails(true); 
                setDetailsModalVisible(false); 
            }}
            style={{
                background: '#52c41a',
                borderColor: '#52c41a',
                fontWeight: 600,
                padding: '8px 16px',
                height: 'auto'
            }}
            icon={<span style={{ fontSize: 16 }}>✓</span>}
        >
            قبول کلیه شرایط و مقررات و ادامه
        </Button>
    ]}
    width={800}
    style={{ top: 20 }}
    bodyStyle={{ padding: '16px 0' }}
>
    {/* نوار اطلاعات */}
    <div style={{
        padding: '8px 16px',
        background: '#f6ffed',
        border: '1px solid #b7eb8f',
        borderRadius: 6,
        marginBottom: 16,
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        fontSize: 13
    }}>
        <span style={{ color: '#389e0d' }}>
            📖 لطفاً شرایط زیر را به دقت مطالعه کنید
        </span>
        <span style={{ 
            background: '#389e0d',
            color: 'white',
            padding: '2px 8px',
            borderRadius: 10,
            fontSize: 11
        }}>
            {selectedPeriod?.comment?.length || 0} کاراکتر
        </span>
    </div>

    <div style={{ 
        maxHeight: '55vh', 
        overflowY: 'auto', 
        lineHeight: 1.8,
        padding: '0 16px',
        border: '1px solid #f0f0f0',
        borderRadius: 6,
        background: '#fafafa'
    }}>
        <div 
            dangerouslySetInnerHTML={{ __html: selectedPeriod?.comment }} 
            style={{ 
                padding: 20,
                background: 'white',
                borderRadius: 4,
                fontSize: 14
            }}
        />
    </div>
    
    {/* هشدار پایین مودال */}
    <div style={{
        marginTop: 16,
        padding: '12px 16px',
        background: '#fff2e8',
        border: '1px solid #ffbb96',
        borderRadius: 6,
        textAlign: 'center'
    }}>
        <Text type="warning" strong style={{ fontSize: 13 }}>
            ⚠️ توجه: با فشردن دکمه "قبول شرایط" شما کلیه شرایط و مقررات فوق را پذیرفته‌اید.
        </Text>
    </div>
</Modal>



                    {/* بخش چک باکس و دکمه شروع رزرو */}
                    <Row className='sectionFooter' style={{ marginTop: 18 }}>
                        <Col span={24} style={{ textAlign: 'center' }}>
                            <div style={{ display: 'inline-block', textAlign: 'left', maxWidth: 720 }}>
                                <Checkbox
                                    checked={acceptedTerms}
                                    onChange={(e) => setAcceptedTerms(e.target.checked)}
                                    disabled={!canToggleCheckbox}
                                >
                                    <span>
                                        من توضیحات تکمیلی را خوانده و شرایط را قبول دارم.
                                    </span>
                                </Checkbox>

                                {!canToggleCheckbox && (
                                    <div style={{ color: '#fa8c16', marginTop: 6 }}>
                                        برای فعال شدن این گزینه ابتدا باید توضیحات را باز و مشاهده کنید.
                                    </div>
                                )}
                            </div>

                            <div style={{ marginTop: 14 }}>
                                <Button
                                    className='btn-primary'
                                    type="primary"
                                    size="large"
                                    style={{
                                        padding: '12px 24px',
                                        borderRadius: 10,
                                        width: 420,
                                        fontSize: 16
                                    }}
                                    onClick={() => { if (onNewReserveClick) onNewReserveClick(selectedPeriod) }}
                                    disabled={!acceptedTerms}
                                >
                                    شروع رزرو
                                    <DoubleLeftOutlined />
                                </Button>
                            </div>
                        </Col>
                    </Row>
                </>
            )}
        </>
    )
}






// import React, { useEffect, useState } from 'react'
// import { GetAll_Active_Now_Period_Api } from '../../API/PeriodApi';
// import { Button, Col, Row } from 'antd';
// import {
//     DoubleLeftOutlined,
// } from '@ant-design/icons';
// // ======================================================================
// export const ShowActivePeriodComponent = ({ setLoading, showMessage, onNewReserveClick }) => {
//     // ======================================================================
//     const [periods, setPeriods] = useState([]);
//     const [selectedPeriod, setSelectedPeriod] = useState();
//     // ======================================================================
//     useEffect(() => {
//         loadData();
//     }, []);
//     // ======================================================================
//     const loadData = async () => {
//         setLoading(true);
//         try {
//             const data = await GetAll_Active_Now_Period_Api();
//             setLoading(false);
//             if (data.messageStatus == "Successful") {
//                 setPeriods(data.messageData.data);
//             }
//             else
//                 showMessage(data.message, "error")
//         }
//         catch (error) {
//             setLoading(false);
//             showMessage("خطا در ارتباط با سرور.", "error")
//         }
//     }
//     // ====================================================================== 
//     return (
//         <>
//             <Row justify="space-around" style={{
//                 marginTop: '15px'
//             }}>
//                 {periods.map((period, key) =>
//                     <Col key={key} xs={23} sm={22} md={11} lg={10} xl={10}
//                         style={{
//                             border: '1px solid rgb(73 68 68 / 50%)',
//                             borderRadius: '5px',
//                             textAlign: 'center',
//                             padding: '10px',
//                             margin: "2px",
//                             cursor: "pointer",
//                             boxShadow: '0 14px 80px rgba(34,35,58,.2)'
//                         }}
//                         className={period.id == selectedPeriod?.id ? 'btn-info' : ''}
//                         onClick={() => { setSelectedPeriod(period) }}
//                     // onClick={() => { if (onNewReserveClick) onNewReserveClick(period) }}
//                     >
//                         <h2>
//                             {period.title}
//                         </h2>

//                         <h3>
//                             {period.categoryTitle}
//                         </h3>
//                     </Col>
//                 )}
//             </Row>
//             <br />
//             <br />

//             {
//                 selectedPeriod ?
//                     <>
//                         <div className='sectionTitle'>
//                             <h2 >
//                                 اطلاعات دوره
//                             </h2>
//                         </div>
//                         <div className='container'>
//                             <Row justify='center' style={{ borderBottom: '1px solid #cdcdcd', paddingTop: '8px', paddingBottom: '8px' }}>
//                                 <Col xs={12} sm={12} md={12} lg={3} xl={3} >
//                                     <div className='active-period-title'>تاریخ شروع ثبت نام:</div>
//                                 </Col>
//                                 <Col xs={12} sm={12} md={12} lg={3} xl={3} >
//                                     <div className='active-period-value'>{selectedPeriod.registration_From_Shamsi}</div>
//                                 </Col>
//                                 <Col xs={24} sm={24} md={24} lg={5} xl={5} >
//                                 </Col>

//                                 <Col xs={12} sm={12} md={12} lg={3} xl={3} >
//                                     <div className='active-period-title'>تاریخ پایان ثبت نام:</div>
//                                 </Col>
//                                 <Col xs={12} sm={12} md={12} lg={3} xl={3} >
//                                     <div className='active-period-value'>{selectedPeriod.registration_To_Shamsi}</div>
//                                 </Col>

//                             </Row>
//                             <Row justify='center' style={{ borderBottom: '1px solid #cdcdcd', paddingTop: '8px', paddingBottom: '8px' }}>
//                                 <Col xs={12} sm={12} md={12} lg={3} xl={3} >
//                                     <div className='active-period-title'>برای اقامت از :</div>
//                                 </Col>
//                                 <Col xs={12} sm={12} md={12} lg={3} xl={3} >
//                                     <div className='active-period-value'>{selectedPeriod.from_Shamsi}</div>
//                                 </Col>
//                                 <Col xs={24} sm={24} md={24} lg={5} xl={5} >
//                                 </Col>

//                                 <Col xs={12} sm={12} md={12} lg={3} xl={3} >
//                                     <div className='active-period-title'>تا تاریخ:</div>
//                                 </Col>
//                                 <Col xs={12} sm={12} md={12} lg={3} xl={3} >
//                                     <div className='active-period-value'>{selectedPeriod.to_Shamsi}</div>
//                                 </Col>
//                             </Row>
//                             {selectedPeriod.isLottery ?
//                                 <>
//                                     <Row justify='center' style={{ borderBottom: '1px solid #cdcdcd', paddingTop: '8px', paddingBottom: '8px' }}>
//                                         <Col xs={12} sm={12} md={12} lg={4} xl={3} >
//                                             <div className='active-period-title'>تاریخ قرعه کشی :</div>
//                                         </Col>
//                                         <Col xs={12} sm={12} md={12} lg={4} xl={3} >
//                                             <div className='active-period-value'>{selectedPeriod.lotteryDate_Shamsi}</div>
//                                         </Col>
//                                         <Col xs={24} sm={24} md={24} lg={4} xl={11} >
//                                         </Col>
//                                     </Row>
//                                 </> : <></>
//                             }
//                         </div>

//                         {selectedPeriod.comment ?
//                             <>
//                                 <div className='sectionTitle'>
//                                     <h2 >
//                                         توضیحات تکمیلی
//                                     </h2>
//                                 </div>
//                                 <div className='container'>
//                                     <Row justify='center' style={{ borderBottom: '1px solid #cdcdcd', paddingTop: '8px', paddingBottom: '8px' }}>
//                                         <Col span={22}>
//                                             <div dangerouslySetInnerHTML={{ __html: selectedPeriod.comment }} />
//                                         </Col>
//                                     </Row>
//                                 </div>
//                             </> : <></>
//                         }

//                     </> : <></>
//             }

//             {selectedPeriod ?
//                 <Row className='sectionFooter'  >
//                     <Col span={24} style={{ textAlign: 'center' }}>
//                         <Button
//                             className='btn-primary'
//                             style={{
//                                 paddingTop: '20px',
//                                 paddingBottom: '20px',
//                                 top: '10px',
//                                 marginLeft: '10px',
//                                 borderRadius: '10px',
//                                 width: '400px'
//                             }}
//                             onClick={() => { if (onNewReserveClick) onNewReserveClick(selectedPeriod) }}
//                         >
//                             شروع رزرو
//                             <DoubleLeftOutlined />
//                         </Button>
//                     </Col>
//                 </Row> : <></>

//             }
//         </>
//     )
// }
